'use client';

import { useState } from 'react';

import { useGetLeaderboardQuery } from '@/store/api/dashboard';

import TabHeader from '../DasboardSidebar/components/TabHeader';
import ReportsLoader from '../Reports/CustomerDetailModal/ReportsLoader';

// Type definitions (use your actual types if you imported them)
interface CustomerItem {
  customerID: number;
  firstname: string;
  lastname: string;
  volume: number;
  isSponsoring: boolean;
  isNPV: boolean;
  isTopPC: boolean;
  isGV: boolean;
}

interface LeaderboardApiResponse {
  sponsoringList: CustomerItem[];
  npvList: CustomerItem[];
  topPcList: CustomerItem[];
  gvList: CustomerItem[];
}

const NPV = 'NPV';
const SPONSORING = 'SPONSORING';
const TOP_PC = 'TOP PC';
const GV = 'GV';

const Leaderboard = () => {
  const [activeTab, setActiveTab] = useState(NPV);

  const tabs = [
    { name: 'NPV', key: NPV },
    { name: 'SPONSORING', key: SPONSORING },
    { name: 'TOP PC', key: TOP_PC },
    { name: 'GV', key: GV },
  ];

  // Fetch data from API
  const { data, error, isLoading, isFetching, refetch } = useGetLeaderboardQuery();

  // Determine which list to show based on activeTab
  const getCurrentList = (): CustomerItem[] => {
    if (!data) return [];
    switch (activeTab) {
      case NPV:
        return data.data.npvList;
      case SPONSORING:
        return data.data.sponsoringList;
      case TOP_PC:
        return data.data.topPcList;
      case GV:
        return data.data.gvList;
      default:
        return [];
    }
  };

  const list = getCurrentList();

  return (
    <div className="v2-shadow-md v2-p-[24px] md:v2-p-[24px] sm:v2-p-4 xs:v2-p-4 v2-bg-white v2-rounded-xs">
      <div className="v2-pb-5 v2-border-b v2-border-[#E5E5E5] v2-mb-5">
        <h2 className="v2-font-sweet-sans-pro-bold v2-font-bold v2-text-xl v2-text-[#333333] v2-text-center">
          PawTree Leaderboard
        </h2>
      </div>
      <div>
        <TabHeader list={tabs} activeTab={activeTab} setActiveTab={setActiveTab} stretchTabs leaderboard />
        {isLoading ? (
          <div className="v2-flex v2-justify-center v2-items-center md:v2-h-[373px] v2-h-[373px] v2-p-8">
            <ReportsLoader />
          </div>
        ) : (
          <div>
            <table className="v2-w-full v2-table-auto">
              <thead>
                <tr>
                  <th className="v2-text-base v2-font-sweet-sans-pro-medium v2-font-medium v2-text-[#101828] v2-py-[15px] v2-px-4 v2-text-left">
                    #
                  </th>
                  <th className="v2-text-base v2-font-sweet-sans-pro-medium v2-font-medium v2-text-[#101828] v2-py-[15px] v2-px-4 v2-text-left">
                    PetPro Name
                  </th>
                  <th className="v2-text-base v2-font-sweet-sans-pro-medium v2-font-medium v2-text-[#101828] v2-py-[15px] v2-px-4 v2-text-center">
                    Amount
                  </th>
                </tr>
              </thead>
              <tbody>
                {isLoading || isFetching ? (
                  <tr>
                    <td colSpan={3} className="v2-text-center v2-p-4">
                      Loading...
                    </td>
                  </tr>
                ) : error ? (
                  <tr>
                    <td colSpan={3} className="v2-text-center v2-p-4 v2-text-red-600">
                      Error loading data.
                    </td>
                  </tr>
                ) : list && list.length > 0 ? (
                  list.map((item, idx) => (
                    <tr key={item.customerID}>
                      <td className="v2-text-base v2-font-sweet-sans-pro v2-font-normal v2-text-[#101828] v2-py-[11px] v2-px-4 v2-text-left">
                        {String(idx + 1).padStart(2, '0')}
                      </td>
                      <td className="v2-text-base v2-font-sweet-sans-pro v2-font-normal v2-text-[#101828] v2-py-[11px] v2-px-4 v2-text-left">
                        {item.firstname} {item.lastname}
                      </td>
                      <td className="v2-text-base v2-font-sweet-sans-pro v2-font-normal v2-text-[#101828] v2-py-[11px] v2-text-right">
                        <p className="v2-text-primary v2-p-1 v2-w-[83px] v2-text-center v2-border v2-border-primary v2-rounded-xs v2-mx-auto">
                          {typeof item.volume === 'number' ? Math.round(item.volume).toLocaleString() : item.volume}
                        </p>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={3} className="v2-text-center v2-p-4">
                      No data found.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
};

export default Leaderboard;
